
import { toMoney } from 'src/legacy/Utils/Conversor';

import { useEventData } from '../hooks';
import { useDiscountStore } from '../stores';
import { format } from 'date-fns';

type Rule = {
  id: number;
  message: string;
};

const useDiscountRules = () => {
  const eventData = useEventData();
  const discountStore = useDiscountStore();
  const rules: Rule[] = [];

  const { discount } = discountStore;

  if (!discount) {
    return rules;
  }

  if (!!discount.unlockPrice) {
    rules.push({
      id: 1,
      message: `Compra mínima de ${toMoney(
        discount.unlockPrice,
      )} (não incluso taxas)`,
    });
  }

  if (
    discount.ticketTypes?.length > 0 &&
    (eventData?.ticketTypes?.length ?? 0) > 1 &&
    discount.ticketTypes?.length !== eventData?.ticketTypes?.length
  ) {
    const ticketTypesNames = eventData?.ticketTypes
      .filter(tt => discount.ticketTypes.map(dtt => dtt.id).includes(tt.id))
      .map(tt => `"${tt.name}"`)
      .join(', ');
    rules.push({
      id: 2,
      message: `Aplicável apenas para os tipos de ingresso: ${ticketTypesNames}`,
    });
  }

  if (!!discount.dateEnd) {
    const dateText = format(discount.dateEnd, "HH:mm 'do dia' dd/MM");
    rules.push({
      id: 3,
      message: `Data de validade: ${dateText} ou até acabar cupons disponíveis`,
    });
  }

  return rules;
};

export default useDiscountRules;
